import { SVGProps } from 'react';

export const BlueonionBlackIcon = (props: SVGProps<SVGSVGElement>) => {
  const css =
    '.cls-1{fill:#000}.cls-2{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px}.cls-3{fill:#3783a4}.cls-4{fill:#a6b8c6}.cls-5{fill:#2163af}.cls-6{fill:#e6e4f2}';

  return <img src="../NXMap-white-blue.png" alt="Evercomm" style={props?.style || { width: 265, marginBottom: 75 }} />;
};
